import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import dayjs from "dayjs";
import Popup from "components/popups/popup";
import Tooltip from "components/tooltips/tooltip";
import {
    InputText,
    InputRadio,
    InputSelect,
    InputHidden,
    InputTextArea,
    InputAddressAutocomplete,
} from "components/formElements";
import Login from "components/login";
import NoMatch from "components/noMatch";
import WorthyApiErrors from "lib/api/worthyApiErrors";
import PopupJBGetPaid from "components/myAccount/popupJBGetPaid";
import { getPaymentDetails, savePaymentDetails } from "actions/user";
import { startAuction } from "actions/item";
import I18n from "lib/i18n/i18n";
import UserActions from "lib/userActions";
import Validators from "lib/validators";
import WorthyApi from "lib/api/worthyApi";
import {
    imageUrl,
    isMobile,
    isJewelers,
    enableBtn,
    disableBtn,
} from "helpers/ApplicationHelper";
import { siteItemPage } from "helpers/itemHelper";
import CoronaPage from "components/coronaStaticPage";

class PopupTooltipRoutingNumber extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    title() {
        return (
            <span>
                {I18n.getString(
                    "user::paymentDetails::bankRoutingNumber::tooltip::title"
                )}
            </span>
        );
    }

    content() {
        return (
            <div>
                {I18n.getString(
                    "user::paymentDetails::bankRoutingNumber::tooltip::text"
                )}
                <br />
                <img
                    src={imageUrl("user/paymentDetails/bankRoutingNumber.png")}
                />
            </div>
        );
    }
}
PopupTooltipRoutingNumber.defaultProps = {
    popupClassName: "popup-tooltip popup-tooltip-routing-number popup-compact",
    single: true,
    modal: true,
    classNames: ["no-animation"],
};

class TooltipRoutingNumber extends Tooltip {
    static initTooltip(props = {}) {
        Tooltip.initTooltip.bind(this)(props);
    }

    content() {
        return (
            <div>
                <h2>
                    {I18n.getString(
                        "user::paymentDetails::bankRoutingNumber::tooltip::title"
                    )}
                </h2>
                {I18n.getString(
                    "user::paymentDetails::bankRoutingNumber::tooltip::text"
                )}
                <br />
                <img
                    src={imageUrl("user/paymentDetails/bankRoutingNumber.png")}
                />
            </div>
        );
    }
}

TooltipRoutingNumber.defaultProps = Object.assign(
    {
        tooltipClassName: "tooltip-routing-number",
    },
    Tooltip.defaultProps
);

class PopupTooltipAccountNumber extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    title() {
        return (
            <span>
                {I18n.getString(
                    "user::paymentDetails::bankAccountNumber::tooltip::title"
                )}
            </span>
        );
    }

    content() {
        return (
            <div>
                {I18n.getString(
                    "user::paymentDetails::bankAccountNumber::tooltip::text"
                )}
                <br />
                <img
                    src={imageUrl("user/paymentDetails/bankAccountNumber.png")}
                />
            </div>
        );
    }
}
PopupTooltipAccountNumber.defaultProps = {
    popupClassName: "popup-tooltip popup-tooltip-account-number popup-compact",
    single: true,
    modal: true,
    classNames: ["no-animation"],
};

class TooltipAccountNumber extends Tooltip {
    static initTooltip(props = {}) {
        Tooltip.initTooltip.bind(this)(props);
    }

    content() {
        return (
            <div>
                <h2>
                    {I18n.getString(
                        "user::paymentDetails::bankAccountNumber::tooltip::title"
                    )}
                </h2>
                {I18n.getString(
                    "user::paymentDetails::bankAccountNumber::tooltip::text"
                )}
                <br />
                <img
                    src={imageUrl("user/paymentDetails/bankAccountNumber.png")}
                />
            </div>
        );
    }
}
TooltipAccountNumber.defaultProps = Object.assign(
    {
        tooltipClassName: "tooltip-account-number",
    },
    Tooltip.defaultProps
);

class PopupTooltipPaypalOption extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    title() {
        return (
            <span>
                {I18n.getString(
                    "user::paymentDetails::howToPay::paypalTooltip::title"
                )}
            </span>
        );
    }

    content() {
        return (
            <div>
                {I18n.getString(
                    "user::paymentDetails::howToPay::paypalTooltip::text"
                )}
            </div>
        );
    }
}
PopupTooltipPaypalOption.defaultProps = {
    popupClassName: "popup-tooltip popup-tooltip-paypal-option popup-compact",
    single: true,
    modal: true,
    classNames: ["no-animation"],
};

class TooltipPaypalOption extends Tooltip {
    static initTooltip(props = {}) {
        Tooltip.initTooltip.bind(this)(props);
    }

    content() {
        return (
            <div>
                <h2>
                    {I18n.getString(
                        "user::paymentDetails::howToPay::paypalTooltip::title"
                    )}
                </h2>
                {I18n.getString(
                    "user::paymentDetails::howToPay::paypalTooltip::text"
                )}
            </div>
        );
    }
}

TooltipPaypalOption.defaultProps = Object.assign(
    {
        tooltipClassName: "tooltip-paypal-option",
    },
    Tooltip.defaultProps
);

class PaymentDetails extends Component {
    constructor(props) {
        super(props);

        this.selectPaymentSection = this.selectPaymentSection.bind(this);
        this._clearAllErrors = this._clearAllErrors.bind(this);
        this._validateIdNumber = this._validateIdNumber.bind(this);
        this._validateDateOfBirth = this._validateDateOfBirth.bind(this);
        this._validateBankName = this._validateBankName.bind(this);
        this._validateBankRoutingNumber =
            this._validateBankRoutingNumber.bind(this);
        this._validateBankAccountNumber =
            this._validateBankAccountNumber.bind(this);
        this._validatePaypalEmail = this._validatePaypalEmail.bind(this);
        this._validateCheckName = this._validateCheckName.bind(this);
        this._validateCheckAddress = this._validateCheckAddress.bind(this);
        this._validateCheckPlainData = this._validateCheckPlainData.bind(this);
        this._validate = this._validate.bind(this);
        this._onSubmit = this._onSubmit.bind(this);

        this.state = {
            currentPaymentSection: "bank_transfer",
        };
    }

    selectPaymentSection(val) {
        this.setState({ currentPaymentSection: val });
    }

    componentDidMount() {
        UserActions.PaymentDetails.pageLoaded();
        this.props.getPaymentDetails(this.props.params.itemId);
    }

    componentDidUpdate() {
        this._userIdType = this.refs["userIdType"];
        this._userIdNumber = this.refs["userIdNumber"];
        this._userSex = this.refs["userSex"];
        this._userBirthdayDay = this.refs["userBirthdayDay"];
        this._userBirthdayMonth = this.refs["userBirthdayMonth"];
        this._userBirthdayYear = this.refs["userBirthdayYear"];
        this._userBirthdayErrors = this.refs["userBirthdayErrors"];
        this._paymentType = this.refs["paymentType"];
        this._paymentBankName = this.refs["paymentBankName"];
        this._paymentBankAccountNumber = this.refs["paymentBankAccountNumber"];
        this._paymentBankRoutingNumber = this.refs["paymentBankRoutingNumber"];
        this._paymentPaypalEmail = this.refs["paymentPaypalEmail"];
        this._paymentCheckPayTo = this.refs["paymentCheckPayTo"];
        this._paymentCheckAddress = this.refs["paymentCheckAddress"];
        this._paymentCheckAddress2 = this.refs["paymentCheckAddress2"];
        this._paymentCheckPlainData = this.refs["paymentCheckPlainData"];
    }

    componentWillReceiveProps(nextProps) {
        try {
            this.selectPaymentSection(
                nextProps.payment_details.payment_details.transfer_type
            );
        } catch (e) {}
    }

    _clearAllErrors() {
        this._userIdNumber.clearErrors();
        this._userBirthdayErrors.clearErrors();
        this._userBirthdayMonth.clearErrors();
        this._userBirthdayDay.clearErrors();
        this._userBirthdayYear.clearErrors();
        this._paymentBankName.clearErrors();
        this._paymentBankRoutingNumber.clearErrors();
        this._paymentBankAccountNumber.clearErrors();
        this._paymentPaypalEmail.clearErrors();
        this._paymentCheckPayTo.clearErrors();
        this._paymentCheckAddress.clearErrors();
        this._paymentCheckPlainData.clearErrors();
    }

    _validateIdNumber() {
        if (isJewelers(this.props.Session)) return Promise.resolve();
        if (
            !this._userIdNumber.state.value ||
            this._userIdNumber.state.value.length < 6
        ) {
            this._userIdNumber.setError(
                I18n.getString("user::paymentDetails::errors::noIdNumber")
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validateDateOfBirth() {
        if (isJewelers(this.props.Session)) return Promise.resolve();
        if (
            !Validators.validateDate(
                parseInt(this._userBirthdayDay.state.value),
                parseInt(this._userBirthdayMonth.state.value),
                parseInt(this._userBirthdayYear.state.value)
            )
        ) {
            this._userBirthdayErrors.setError(
                I18n.getString(
                    "user::paymentDetails::errors::dateOfBirthIsInvalid"
                )
            );
            this._userBirthdayMonth.setError("");
            this._userBirthdayDay.setError("");
            this._userBirthdayYear.setError("");
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else if (
            Validators.getAge(
                parseInt(this._userBirthdayDay.state.value),
                parseInt(this._userBirthdayMonth.state.value),
                parseInt(this._userBirthdayYear.state.value)
            ) < 18
        ) {
            this._userBirthdayErrors.setError(
                I18n.getString("user::paymentDetails::errors::not18yearsOld")
            );
            this._userBirthdayMonth.setError("");
            this._userBirthdayDay.setError("");
            this._userBirthdayYear.setError("");
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validateBankName() {
        if (!this._paymentBankName.state.value) {
            this._paymentBankName.setError(
                I18n.getString("user::paymentDetails::errors::noBankName")
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validateBankRoutingNumber() {
        let val = this._paymentBankRoutingNumber.state.value;
        if (val && this._isUnchangedValue("_paymentBankRoutingNumber"))
            return Promise.resolve();
        if (!val || !val.match(/^\d{9}$/)) {
            this._paymentBankRoutingNumber.setError(
                I18n.getString(
                    "user::paymentDetails::errors::noBankRoutingNumber"
                )
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validateBankAccountNumber() {
        let val = this._paymentBankAccountNumber.state.value;
        if (val && this._isUnchangedValue("_paymentBankAccountNumber"))
            return Promise.resolve();
        if (!val || !val.match(/^\d+$/)) {
            this._paymentBankAccountNumber.setError(
                I18n.getString(
                    "user::paymentDetails::errors::noBankAccountNumber"
                )
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validatePaypalEmail() {
        if (!Validators.validateEmail(this._paymentPaypalEmail.state.value)) {
            this._paymentPaypalEmail.setError(
                I18n.getString("user::paymentDetails::errors::noPaypal")
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validateCheckName() {
        if (!this._paymentCheckPayTo.state.value) {
            this._paymentCheckPayTo.setError(
                I18n.getString("user::paymentDetails::errors::noCheckName")
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validateCheckAddress() {
        if (!this._paymentCheckAddress.state.value) {
            this._paymentCheckAddress.setError(
                I18n.getString("user::paymentDetails::errors::noCheckAddress")
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validateCheckPlainData() {
        if (!this._paymentCheckPlainData.state.value) {
            this._paymentCheckPlainData.setError(
                I18n.getString("user::paymentDetails::errors::noCheckPlainData")
            );
            enableBtn(this.refs.paymentSubmit);
            return Promise.reject();
        } else {
            return Promise.resolve();
        }
    }

    _validate() {
        switch (this._paymentType.state.value) {
            case "bank_transfer":
                return Promise.all([
                    this._userIdNumber.props.validator(),
                    this._userBirthdayDay.props.validator(),
                    this._paymentBankName.props.validator(),
                    this._paymentBankAccountNumber.props.validator(),
                    this._paymentBankRoutingNumber.props.validator(),
                ]);
                break;
            case "paypal":
                return Promise.all([
                    this._userIdNumber.props.validator(),
                    this._userBirthdayDay.props.validator(),
                    this._paymentPaypalEmail.props.validator(),
                ]);
                break;
            case "check2":
                if (this.props.payment_details.isCheckDataPlain) {
                    return Promise.all([
                        this._userIdNumber.props.validator(),
                        this._userBirthdayDay.props.validator(),
                        this._paymentCheckPlainData.props.validator(),
                    ]);
                } else {
                    return Promise.all([
                        this._userIdNumber.props.validator(),
                        this._userBirthdayDay.props.validator(),
                        this._paymentCheckPayTo.props.validator(),
                        this._paymentCheckAddress.props.validator(),
                    ]);
                }
                break;
            default:
                return new Promise(function (resolve, reject) {
                    reject();
                });
                break;
        }
    }

    _isUnchangedValue(field) {
        return this[field].state.value === this[field].props.defaultValue;
    }

    _checkAndGetUpdatedValue(field, isMasked) {
        if (!isMasked) {
            return !this._isUnchangedValue(field)
                ? this[field].state.value
                : this[field].props.defaultValue;
        }

        return !this._isUnchangedValue(field) ? this[field].state.value : null;
    }

    _getPaymentDetails() {
        const transfer_type = this._checkAndGetUpdatedValue("_paymentType");
        return {
            item_id: this.props.params.itemId,
            payment_details: {
                transfer_type,
                bank: {
                    bank_name:
                        transfer_type === "bank_transfer"
                            ? this._checkAndGetUpdatedValue("_paymentBankName")
                            : null,
                    account_number:
                        transfer_type === "bank_transfer"
                            ? this._checkAndGetUpdatedValue(
                                  "_paymentBankAccountNumber",
                                  true
                              )
                            : null,
                    routing_number:
                        transfer_type === "bank_transfer"
                            ? this._checkAndGetUpdatedValue(
                                  "_paymentBankRoutingNumber",
                                  true
                              )
                            : null,
                },
                paypal:
                    transfer_type === "paypal"
                        ? this._checkAndGetUpdatedValue(
                              "_paymentPaypalEmail",
                              true
                          )
                        : null,
                check:
                    transfer_type === "check2"
                        ? this._checkAndGetUpdatedValue(
                              "_paymentCheckPlainData",
                              true
                          )
                        : null,
            },
            user_info: {
                id_type: this._checkAndGetUpdatedValue("_userIdType"),
                id_number: this._checkAndGetUpdatedValue("_userIdNumber", true),
                sex: this._checkAndGetUpdatedValue("_userSex"),
                birthday: `${this._checkAndGetUpdatedValue(
                    "_userBirthdayYear"
                )}-${this._checkAndGetUpdatedValue(
                    "_userBirthdayMonth"
                )}-${this._checkAndGetUpdatedValue("_userBirthdayDay")}`,
            },
        };
    }

    _onSubmit(event) {
        event.preventDefault();
        disableBtn(this.refs.paymentSubmit);

        this._clearAllErrors();

        this._validate().then(() => {
            const paymentDetails = this._getPaymentDetails();

            this.props.savePaymentDetails(paymentDetails).then(() => {
                if (
                    !!this.props.payment_details.item &&
                    this.props.payment_details.item.workflow_state ===
                        "evaluation_bid"
                ) {
                    window.location = siteItemPage(
                        this.props.payment_details.item.id
                    );
                } else if (
                    this.props.payment_details.item &&
                    this.props.payment_details.item.workflow_state ===
                        "pending_sale"
                ) {
                    WorthyApi.acceptSpecialSale(
                        this.props.payment_details.item.id,
                        {}
                    ).then(() => {
                        window.location = `/item/${this.props.payment_details.item.id}`;
                    });
                } else if (this.props.location.query.action === "getPaid") {
                    let feesRate = this.props.location.query.f ? atob(this.props.location.query.f) : this.props.ADO.jb_fees_rate;

                    if (Number.isNaN(parseFloat(feesRate))) {
                        feesRate = this.props.ADO.jb_fees_rate;
                    }

                    PopupJBGetPaid.initPopup({
                        bundleId: this.props.location.query.bundleId,
                        totalValue: this.props.location.query.totalValue,
                        paymentDetails: paymentDetails.payment_details,
                        feesRate,
                        returnUrl: `/items/${this.props.location.query.bundleId}`,
                    });
                } else {
                    UserActions.PaymentDetails.auctionStarted();
                    return this.props
                        .startAuction(this.props.payment_details.item.id, {})
                        .then(() => {
                            window.location = siteItemPage(
                                this.props.payment_details.item.id
                            );
                        });
                }
            });
        });
    }

    render() {
        let { ADO } = this.props;
        if (!ADO) return null;

        if (ADO.corona_user_ids && ADO.corona_user_ids.includes(ADO.user.id)) {
            return <CoronaPage />;
        }

        if (!this.props.Session || !this.props.payment_details) return null;
        if (!this.props.Session.isLoggedIn) {
            return (
                <Login
                    onLoginSuccessful={() => {
                        this.props.getPaymentDetails(this.props.params.itemId);
                    }}
                    showLinkToRegister={false}
                />
            );
        }
        if (this.props.payment_details instanceof WorthyApiErrors)
            if (this.props.payment_details.hasError(404)) return <NoMatch />;
            else return null;

        let _days = { 0: "DD" };
        for (let i = 1; i <= 31; i++) {
            _days[i] = i;
        }
        let _months = { 0: "MM" };
        for (let i = 1; i <= 12; i++) {
            _months[i] = i;
        }
        let _years = { 0: "YYYY" };
        for (
            let i = new Date().getFullYear() - 120;
            i <= new Date().getFullYear() - 18;
            i++
        ) {
            _years[i] = i;
        }

        let birthday = this.props.payment_details.user_info.birthday || "0-0-0";
        let birthdayDay = parseInt(birthday.split("-")[2]).toString();
        let birthdayMonth = parseInt(birthday.split("-")[1]).toString();
        let birthdayYear = parseInt(birthday.split("-")[0]).toString();

        return (
            <div id="user-payment-details">
                {(() => {
                    if (
                        !!this.props.payment_details.item &&
                        !!this.props.payment_details.item.interested_buyers
                    ) {
                        return (
                            <div className="interested-buyers">
                                <strong>
                                    {I18n.getString(
                                        "user::paymentDetails::yourActionIsLive"
                                    )}
                                </strong>
                                &nbsp;
                                {I18n.getJsx(
                                    "user::paymentDetails::yourActionIsLive_buyers",
                                    {
                                        buyers: (
                                            <span>
                                                {
                                                    this.props.payment_details
                                                        .item.interested_buyers
                                                }
                                            </span>
                                        ),
                                    }
                                )}
                            </div>
                        );
                    }
                })()}
                <h1>{I18n.getString("user::paymentDetails::title")}</h1>
                <div className="desc">
                    {I18n.getString("user::paymentDetails::text1")}
                </div>
                <form onSubmit={this._onSubmit}>
                    <div
                        id="user-info-section"
                        className={
                            isJewelers(this.props.Session) ? "hidden" : ""
                        }
                    >
                        <InputRadio
                            options={{
                                "State driver license": I18n.getString(
                                    "user::paymentDetails::idNumber::typeDriverLicense"
                                ),
                                Passport: I18n.getString(
                                    "user::paymentDetails::idNumber::typePassport"
                                ),
                            }}
                            defaultValue={
                                this.props.payment_details.user_info.id_type
                            }
                            ref="userIdType"
                            name="userIdType"
                            label={
                                <h3>
                                    {I18n.getString(
                                        "user::paymentDetails::idNumber::title"
                                    )}
                                </h3>
                            }
                            onAfterChange={(val) => {
                                UserActions.PaymentDetails.idTypeSelected(val);
                            }}
                        />
                        <InputText
                            defaultValue={
                                this.props.payment_details.user_info.id_number
                            }
                            ref="userIdNumber"
                            name="userIdNumber"
                            validator={this._validateIdNumber}
                            clearErrorOnChange={true}
                            inputProps={{
                                placeholder: I18n.getString(
                                    "user::paymentDetails::idNumber::placeholder"
                                ),
                                onFocus: (event) => {
                                    UserActions.PaymentDetails.idFocus();
                                },
                                onBlur: (event) => {
                                    UserActions.PaymentDetails.idEntered(
                                        event.target.value
                                    );
                                },
                            }}
                        />

                        <InputRadio
                            options={{
                                f: I18n.getString(
                                    "user::paymentDetails::gender::f"
                                ),
                                m: I18n.getString(
                                    "user::paymentDetails::gender::m"
                                ),
                            }}
                            defaultValue={
                                this.props.payment_details.user_info.sex
                            }
                            ref="userSex"
                            name="userSex"
                            label={
                                <h3>
                                    {I18n.getString(
                                        "user::paymentDetails::gender::title"
                                    )}
                                </h3>
                            }
                            onAfterChange={(val) => {
                                UserActions.PaymentDetails.genderSelected(val);
                            }}
                        />

                        <div className="birthday-section">
                            <h3>
                                {I18n.getString(
                                    "user::paymentDetails::birthday::title"
                                )}
                            </h3>
                            <InputSelect
                                ref="userBirthdayMonth"
                                name="userBirthdayMonth"
                                validator={this._validateDateOfBirth}
                                defaultValue={birthdayMonth}
                                options={_months}
                                className="birthday-month"
                                onBeforeChange={(val) => {
                                    UserActions.PaymentDetails.dobMonthSelected(
                                        val
                                    );
                                }}
                                onAfterChange={() => {
                                    this._userBirthdayDay.clearErrors();
                                    this._userBirthdayMonth.clearErrors();
                                    this._userBirthdayYear.clearErrors();
                                    this._userBirthdayErrors.clearErrors();
                                }}
                                inputProps={{
                                    onClick: () => {
                                        UserActions.PaymentDetails.dobMonthOpened();
                                    },
                                }}
                            />
                            <InputSelect
                                ref="userBirthdayDay"
                                name="userBirthdayDay"
                                validator={this._validateDateOfBirth}
                                defaultValue={birthdayDay}
                                options={_days}
                                className="birthday-day"
                                onBeforeChange={(val) => {
                                    UserActions.PaymentDetails.dobDaySelected(
                                        val
                                    );
                                }}
                                onAfterChange={() => {
                                    this._userBirthdayDay.clearErrors();
                                    this._userBirthdayMonth.clearErrors();
                                    this._userBirthdayYear.clearErrors();
                                    this._userBirthdayErrors.clearErrors();
                                }}
                                inputProps={{
                                    onClick: () => {
                                        UserActions.PaymentDetails.dobDayOpened();
                                    },
                                }}
                            />
                            <InputSelect
                                ref="userBirthdayYear"
                                name="userBirthdayYear"
                                validator={this._validateDateOfBirth}
                                defaultValue={birthdayYear}
                                options={_years}
                                className="birthday-year"
                                onBeforeChange={(val) => {
                                    UserActions.PaymentDetails.dobYearSelected(
                                        val
                                    );
                                }}
                                onAfterChange={() => {
                                    this._userBirthdayDay.clearErrors();
                                    this._userBirthdayMonth.clearErrors();
                                    this._userBirthdayYear.clearErrors();
                                    this._userBirthdayErrors.clearErrors();
                                }}
                                inputProps={{
                                    onClick: () => {
                                        UserActions.PaymentDetails.dobYearOpened();
                                    },
                                }}
                            />
                            <InputHidden
                                ref="userBirthdayErrors"
                                name="userBirthdayErrors"
                            />
                        </div>
                    </div>
                    <div
                        id="payment-details-section"
                        data-active-section={this.state.currentPaymentSection}
                    >
                        <InputRadio
                            options={{
                                bank_transfer: I18n.getString(
                                    "user::paymentDetails::howToPay::bank"
                                ),
                                paypal: I18n.getString(
                                    "user::paymentDetails::howToPay::paypal"
                                ),
                            }}
                            paypalLable={"payment-details-paypal-option"}
                            tooltip={
                                <a
                                    className="tooltipButton"
                                    onClick={() => {
                                        if (isMobile())
                                            PopupTooltipPaypalOption.initPopup();
                                    }}
                                    onMouseEnter={(event) => {
                                        if (!isMobile())
                                            TooltipPaypalOption.initTooltip({
                                                sender: event.target,
                                            });
                                    }}
                                />
                            }
                            showTooltip={I18n.getString(
                                "user::paymentDetails::howToPay::paypal"
                            )}
                            breakBetweenOptions={true}
                            defaultValue={
                                this.props.payment_details.payment_details
                                    .transfer_type
                            }
                            ref="paymentType"
                            name="paymentType"
                            onAfterChange={(val) => {
                                this.selectPaymentSection(val);
                                UserActions.PaymentDetails.paymentTypeSelected(
                                    val
                                );
                            }}
                            label={
                                <h3>
                                    {I18n.getString(
                                        "user::paymentDetails::howToPay::title"
                                    )}
                                </h3>
                            }
                        />
                        <div
                            className="section section-bank_transfer"
                            id="payment-details-bank_transfer-section"
                        >
                            <InputText
                                ref="paymentBankAccountHolderName"
                                name="paymentBankAccountHolderName"
                                clearErrorOnChange={true}
                                defaultValue={
                                    this.props.Session.isLoggedIn
                                        ? this.props.Session.userData.name
                                        : ""
                                }
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::bankAccountHolderName::title"
                                        )}
                                    </h3>
                                }
                                inputProps={{
                                    disabled: true,
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::bankAccountHolderName::placeholder"
                                    ),
                                }}
                            />
                            <InputText
                                ref="paymentBankName"
                                name="paymentBankName"
                                clearErrorOnChange={true}
                                validator={this._validateBankName}
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .bank
                                        ? this.props.payment_details
                                              .payment_details.bank.bank_name
                                        : ""
                                }
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::bankName::title"
                                        )}
                                    </h3>
                                }
                                inputProps={{
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::bankName::placeholder"
                                    ),
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.bankNameFocus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.bankNameEntered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                            <InputText
                                ref="paymentBankRoutingNumber"
                                name="paymentBankRoutingNumber"
                                clearErrorOnChange={true}
                                validator={this._validateBankRoutingNumber}
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .bank
                                        ? this.props.payment_details
                                              .payment_details.bank
                                              .routing_number
                                        : ""
                                }
                                hasLabelFor={false}
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::bankRoutingNumber::title"
                                        )}
                                        <a
                                            className="tooltipButton"
                                            onClick={() => {
                                                if (isMobile())
                                                    PopupTooltipRoutingNumber.initPopup();
                                            }}
                                            onMouseEnter={(event) => {
                                                if (!isMobile())
                                                    TooltipRoutingNumber.initTooltip(
                                                        { sender: event.target }
                                                    );
                                            }}
                                        ></a>
                                    </h3>
                                }
                                inputProps={{
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::bankRoutingNumber::placeholder"
                                    ),
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.bankRoutingNumberFocus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.bankRoutingNumberEntered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                            <InputText
                                ref="paymentBankAccountNumber"
                                name="paymentBankAccountNumber"
                                clearErrorOnChange={true}
                                validator={this._validateBankAccountNumber}
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .bank
                                        ? this.props.payment_details
                                              .payment_details.bank
                                              .account_number
                                        : ""
                                }
                                hasLabelFor={false}
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::bankAccountNumber::title"
                                        )}
                                        <a
                                            className="tooltipButton"
                                            onClick={() => {
                                                if (isMobile())
                                                    PopupTooltipAccountNumber.initPopup();
                                            }}
                                            onMouseEnter={(event) => {
                                                if (!isMobile())
                                                    TooltipAccountNumber.initTooltip(
                                                        { sender: event.target }
                                                    );
                                            }}
                                        ></a>
                                    </h3>
                                }
                                inputProps={{
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::bankAccountNumber::placeholder"
                                    ),
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.bankAccountNumberFocus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.bankAccountNumberEntered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                        </div>
                        <div
                            className="section section-paypal"
                            id="payment-details-paypal-section"
                        >
                            <InputText
                                ref="paymentPaypalName"
                                name="paymentPaypalName"
                                clearErrorOnChange={true}
                                defaultValue={
                                    this.props.Session.isLoggedIn
                                        ? this.props.Session.userData.name
                                        : ""
                                }
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::paypalFullName::title"
                                        )}
                                    </h3>
                                }
                                inputProps={{
                                    disabled: true,
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::paypalFullName::placeholder"
                                    ),
                                }}
                            />
                            <InputText
                                ref="paymentPaypalEmail"
                                name="paymentPaypalEmail"
                                clearErrorOnChange={true}
                                validator={this._validatePaypalEmail}
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .paypal
                                }
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::paypalUserName::title"
                                        )}
                                    </h3>
                                }
                                inputProps={{
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::paypalUserName::placeholder"
                                    ),
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.paypalFocus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.paypalEntered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                        </div>
                        <div
                            className="section section-check"
                            id="payment-details-check-section"
                        >
                            <div className="check2-transfer-costs">
                                $
                                {
                                    this.props.payment_details
                                        .check2_transfer_costs
                                }{" "}
                                {I18n.getString(
                                    "user::paymentDetails::checkPayTo::fees"
                                )}
                            </div>
                            <InputText
                                ref="paymentCheckPayTo"
                                name="paymentCheckPayTo"
                                clearErrorOnChange={true}
                                className={
                                    this.props.payment_details.isCheckDataPlain
                                        ? "hidden"
                                        : ""
                                }
                                validator={this._validateCheckName}
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .check
                                        ? this.props.payment_details
                                              .payment_details.check.name
                                        : ""
                                }
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::checkPayTo::title"
                                        )}
                                    </h3>
                                }
                                inputProps={{
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::checkPayTo::placeholder"
                                    ),
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.checkNameFocus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.checkNameEntered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                            <InputAddressAutocomplete
                                ref="paymentCheckAddress"
                                name="paymentCheckAddress"
                                clearErrorOnChange={true}
                                className={
                                    this.props.payment_details.isCheckDataPlain
                                        ? "hidden"
                                        : ""
                                }
                                validator={this._validateCheckAddress}
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .check
                                        ? this.props.payment_details
                                              .payment_details.check.address1
                                        : ""
                                }
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::checkMailingAddress::title"
                                        )}
                                    </h3>
                                }
                                inputProps={{
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::checkMailingAddress::placeholder"
                                    ),
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.checkAddressFocus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.checkAddressEntered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                            <InputText
                                ref="paymentCheckAddress2"
                                name="paymentCheckAddress2"
                                clearErrorOnChange={true}
                                className={
                                    this.props.payment_details.isCheckDataPlain
                                        ? "hidden"
                                        : ""
                                }
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .check
                                        ? this.props.payment_details
                                              .payment_details.check.address2
                                        : ""
                                }
                                label={
                                    <h3>
                                        {I18n.getString(
                                            "user::paymentDetails::checkMailingAddress2::title"
                                        )}
                                    </h3>
                                }
                                inputProps={{
                                    placeholder: I18n.getString(
                                        "user::paymentDetails::checkMailingAddress2::placeholder"
                                    ),
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.checkAddress2Focus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.checkAddress2Entered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                            <InputTextArea
                                ref="paymentCheckPlainData"
                                name="paymentCheckPlainData"
                                clearErrorOnChange={true}
                                className={
                                    this.props.payment_details.isCheckDataPlain
                                        ? ""
                                        : "hidden"
                                }
                                defaultValue={
                                    this.props.payment_details.payment_details
                                        .check
                                }
                                validator={this._validateCheckPlainData}
                                inputProps={{
                                    onFocus: (event) => {
                                        UserActions.PaymentDetails.checkDetailsFocus();
                                    },
                                    onBlur: (event) => {
                                        UserActions.PaymentDetails.checkDetailsEntered(
                                            event.target.value
                                        );
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div id="submit-section">
                        <button
                            type="submit"
                            className="btn btn-orange"
                            ref="paymentSubmit"
                            onClick={() => {
                                UserActions.PaymentDetails.submit();
                            }}
                        >
                            {(() => {
                                if (this.props.payment_details.item) {
                                    if (
                                        this.props.payment_details.item
                                            .can_be_scheduled &&
                                        this.props.payment_details.item
                                            .scheduled_auction_upcoming_date
                                    ) {
                                        return (
                                            <span
                                                style={{ margin: "0 20px" }}
                                                dangerouslySetInnerHTML={{
                                                    __html: I18n.getString(
                                                        "user::paymentDetails::submitButtonScheduledAuction",
                                                        {
                                                            date: dayjs(
                                                                this.props
                                                                    .payment_details
                                                                    .item
                                                                    .scheduled_auction_upcoming_date
                                                            ).format(
                                                                "MM/DD/YYYY"
                                                            ),
                                                        }
                                                    ),
                                                }}
                                            />
                                        );
                                    }
                                    if (
                                        this.props.payment_details.item
                                            .bundle_type === "jewelry_box"
                                    )
                                        return I18n.getString(
                                            "user::paymentDetails::submitButtonJB"
                                        );
                                    else if (
                                        this.props.payment_details.item
                                            .workflow_state == "evaluation_bid"
                                    )
                                        return I18n.getString(
                                            "user::paymentDetails::submitButton"
                                        );
                                    else if (
                                        this.props.payment_details.item
                                            .advance_payment
                                    )
                                        return I18n.getString(
                                            "user::paymentDetails::submitButtonGetPaidStartAuction"
                                        );
                                    else
                                        return I18n.getString(
                                            "user::paymentDetails::submitButtonNoItem"
                                        );
                                } else
                                    return I18n.getString(
                                        "user::paymentDetails::submitButtonGetPaidMyAccount"
                                    );
                            })()}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = ({ Session, ADO, PaymentDetails }) => {
    return {
        Session,
        ADO,
        payment_details: PaymentDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { getPaymentDetails, savePaymentDetails, startAuction },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetails);
